import type { GroupService, IGroup } from '../../group/group.service'
import type { RestangularService } from '../common/restangular.service'

import { app } from '../../app.module'

/**
 * グループ選択用パネルのコンポネント
 * @class SelectGroupPanel
 */
class SelectGroupPanel {
  private groupList: IGroup[]

  constructor(
    private localStorageService,
    private GroupService: GroupService,
    private RestangularService: RestangularService
  ) {
    this.init()
  }

  /**
   * 初期化
   */
  public init() {
    this.groupList = []
    this.getGroupList()
  }

  /**
   * 対象ユーザーのグループ一覧を取得
   */
  private getGroupList() {
    const endpoint = '/users/getGroupData'
    const params = {}

    this.RestangularService.request('GET', endpoint, params).then((result) => {
      // グループがない場合、リターン
      if (result[0].data === null || result[0].data.length === 0) {
        return
      }
      this.groupList = result[0].data

      // ローカルストレージから情報を取得し、表示するグループを選択
      const selectedGroup = this.getGroupToShow()
      // 選択したグループの情報をルートスコープに格納
      this.GroupService.setGroupData(selectedGroup)
    })
  }

  /**
   * ローカルストレージから過去に選択したグループを取得し、
   * 取得したグループ一覧と突合し、表示するグループを選択する
   */
  private getGroupToShow(): IGroup {
    // ローカルストレージから、前回選択されたグループIDを取得
    const localStoragedGroupId: number = this.localStorageService.get('selectedGroupId')

    // ローカルにデータが保存されていない場合、取得したグループの先頭を選択したグループとする
    if (localStoragedGroupId === undefined || localStoragedGroupId === null) {
      return this.groupList[0]
    }

    // ローカルにデータが保存されていた場合は、取得したデータと突合し、存在すれば選択したグループとする
    const storagedGroup = this.groupList.filter((group) => {
      return group.groupId === localStoragedGroupId
    })

    if (storagedGroup[0] !== undefined) {
      return storagedGroup[0]
    }

    // 取得したグループデータとローカルのデータが合致しなかった場合、取得したグループの先頭を選択したグループとする
    return this.groupList[0]
  }
}

app.component('selectGroupPanel', {
  template: require('./select-group-panel.pug')(),
  controller: SelectGroupPanel,
})
